import React from 'react';

import {
  FormItem,
  Input,
  AutoComplete,
  Loading,
  RadioGroup,
} from '../../../../components';
import { languages } from '../../../../utilities';
import type { FormProps } from './CallTaskWizard';
import { validateName } from '../../utils/validator';

interface FirstStepWizardProps {
  values: FormProps;
}

const FirstStepWizard: React.FC<FirstStepWizardProps> = ({ values }) => {
  const availableAgents = [
    { id: '1', label: 'Agent 1' },
    { id: '2', label: 'Agent 2' },
    { id: '3', label: 'Agent 3' },
    { id: '4', label: 'Agent 4' },
    { id: '5', label: 'Agent 5' },
    { id: '6', label: 'Agent 6' },
  ];

  return (
    <div className="flex flex-col gap-y-2 max-w-5xl w-full h-[50vh] px-2 overflow-y-auto mt-10">
      <div className="flex flex-col gap-y-1 mb-md">
        <h3 className="text-2xl font-semibold">Choose Agent</h3>
        <span className="text-tiny text-secondary">
          These details ensure more accurate results
        </span>
      </div>
      <FormItem<FormProps>
        required
        labelClassName="text-tiny"
        name="taskName"
        label="Task Name"
        inline={false}
        validate={validateName}
      >
        <Input value={values.taskName} />
      </FormItem>
      <FormItem<FormProps>
        required
        labelClassName="text-tiny"
        name="language"
        label="Language"
        inline={false}
      >
        <AutoComplete options={languages} />
      </FormItem>
      <FormItem<FormProps>
        required
        labelClassName="text-tiny"
        name="outboundPhoneNumber"
        label="Outbound SIP trunk phone number"
        inline={false}
      >
        <AutoComplete
          options={[{ label: '1234567890', value: '1234567890' }]}
        />
      </FormItem>
      {!availableAgents.length ? (
        <div className="flex justify-center items-center">
          <Loading />
        </div>
      ) : (
        <FormItem
          labelClassName="text-tiny"
          name="callAgentName"
          label="Choose calling Agent"
          inline={false}
          required
        >
          {availableAgents?.length ? (
            <RadioGroup
              className="max-h-[80px] overflow-y-auto"
              direction="column"
              labelPosition="left"
              itemClass="flex justify-between"
              options={availableAgents}
            />
          ) : (
            <div className="flex justify-center items-center text-small">
              No Data Available
            </div>
          )}
        </FormItem>
      )}
      <div className="mt-1">
        <FormItem<FormProps>
          required
          labelClassName="text-tiny"
          name="agentCallInstruction"
          label={'Agent Call Instruction'}
          inline={false}
        >
          <Input multiline />
        </FormItem>
      </div>
    </div>
  );
};

export default FirstStepWizard;
